import usePrivateLink from "../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { Link } from "react-router-dom";
import { closeModal, ToastMain ,SweetAlertShow} from "../master/Master";
import { BusRoute, BusRouteAdd, BusRouteDelete, BusRouteUpdate, GetBus } from "../../api/BusService";
import Swal from "sweetalert2";
import BusHeader from "./BusHeader";

export default function BusRoutes() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [buses, setBuses] = useState([]);
  const [routeList, setRouteList] = useState([]);
  const [modalData, setModalData] = useState("");
  const[error, setError]=useState('')

  const busList = async () => {
    setLoading(true);
    try {
      const response = await GetBus();
      if (response.data.status) {
        setBuses(response.data.data || []);
      } else {
        SweetAlertShow('info','Warning',response?.data?.message)
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ??  error?.response?.message ?? error?.message)
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };

  const busRoutesList = async () => {
    setLoading(true);
    try {
      const response = await BusRoute();
      if (response.data.status) {
        setRouteList(response.data.data || []);
      } else {
        SweetAlertShow('info','Warning',response?.data?.message)
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };
  const newBus = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await BusRouteAdd(formData);
      if (response.data.status) {
        setError('')
        closeModal("AddBus")
        busRoutesList();
        SweetAlertShow('success','Successfully',response?.data?.message)
        // ToastMain.fire({
        //   icon: "success",
        //   title: "Created Successfully!",
        // })

      } else {
        if(response?.data?.errors){
          setError(response?.data?.errors)
        }

        SweetAlertShow('info','Warning',response?.data?.message )
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // }).then(() => {
        //   setLoading(false);
        // });
      }
    } catch (error) {
      if(error?.response?.data?.errors){
        setError(error?.response?.data?.errors)
      }
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // })
    } finally {

      setLoading(false);
    }
  };

  const updateBus = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await BusRouteUpdate(formData);
      if (response.data.status) {
        setError('')
        closeModal("UpdateBus")
        busRoutesList();
        SweetAlertShow('success','Successfully',response?.data?.message)
        // ToastMain.fire({
        //   icon: "success",
        //   title: "Update Successfully!",
        // })

      } else {
        if(response?.data?.errors){
          setError(response?.data?.errors)
        }

        SweetAlertShow('info','Warning',response?.data?.message)
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
      }
    } catch (error) {
      if(error?.response?.data?.errors){
        setError(error?.response?.data?.errors)
      }

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };

  const deleteBus = async (id) => {
    setLoading(true);
    try {
      const response = await BusRouteDelete(id);
      if (response.data.status) {
        busRoutesList();
        ToastMain.fire({
          icon: "success",
          title: "Delete Successfully!",
        }).then(() => {
          busRoutesList();
        });
      } else {
        SweetAlertShow('info','Warning',response?.data?.message)
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ??  error?.response?.message ?? error?.message)
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    busRoutesList();
    busList();
  }, []);
return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                
                <div className="row">
                  <div className="d-flex gap-2">
                    <div className="col-md-3">
                      <BusHeader data={'Bus Portal'}/>
                    </div>
                    <div className="col-md-9">
                      <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between">
                      <h4 className="text-primary">Bus Routes</h4>
                      {hasAccess('/bus/routes/add') && (
                        <button
                          className="btn btn-primary d-inline-flex align-items-center overflow-hidden  transition-button"
                          data-bs-toggle="modal"
                          data-bs-target="#AddBus"
                        >
                          <span className="icon">
                            <i className="bi bi-plus-circle-dotted"></i>
                          </span>
                          <span className="text ms-1">New Route</span>
                        </button>
                      )}
                    </div>
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="table">
                          <tr>
                            <th>#</th>
                            <th>Bus Number</th>
                            <th>Driver Name</th>
                            <th>Route Name</th>
                            <th>Route Fees</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="text-capitalize">
                          {routeList.map((bus, index) => (
                            <tr key={index}>
                              <td>{index + 1 || 'N/A'}</td>
                              <td>{bus.bus?.bus_number || "N/A"}</td>
                              <td>{bus.bus?.driver_name || "N/A"}</td>
                              <td>{bus.route_name || "N/A"}</td>
                              <td>₹{bus.route_fee}</td>
                              <td className="d-flex gap-2">
                                {hasAccess('/bus/routes/update') && (
                                  <button
                                    className="btn btn-sm btn-outline-primary px-2 py-1"
                                    onClick={() => setModalData(bus)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#UpdateBus"
                                  >
                                    <i className="bi bi-pencil-square"></i>
                                  </button>
                                )}

                                {hasAccess('/bus/routes/delete') && bus?.students_count < 1 && (
                                  <button
                                    className="btn btn-sm btn-outline-danger px-2 py-1"
                                    onClick={() =>
                                      Swal.fire({
                                        title: "Are you sure?",
                                        text: "This action will permanently delete the Batch!",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#d33",
                                        cancelButtonColor: "#6c757d",
                                        confirmButtonText: "Yes, delete it!",
                                        cancelButtonText: "Cancel",
                                      }).then(async (result) => {
                                        if (result.isConfirmed) {
                                          deleteBus(bus.id);
                                        }
                                      })
                                    }
                                  >
                                    <i className="bi bi-trash-fill"></i>
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="AddBus"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form
              onSubmit={newBus}
            >
              <div className="modal-header bg-label-primary p-4">
                <h1 className="modal-title fs-5 ">Add Bus Route</h1>
                <button
                  type="button"
                  className="btn-close "
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="mb-3 form-floating form-floating-outline">
                  <select className="form-select" name="bus_id" required>
                    <option value="" selected disabled>
                      Select Bus
                    </option>
                    {buses.map((bus) => (
                      <option key={bus.id} value={bus.id}>
                        {bus.bus_number}
                      </option>
                    ))}
                  </select>
                  <label>-- Select Bus --</label>
                  <span className="text-danger">{error?.bus_id ?? ''}</span>
                </div>
                <div className="mb-3 form-floating form-floating-outline">
                  <input
                    type="text"
                    className="form-control input-uppercase"
                    name="route_name"
                    required
                    placeholder="Route Name"
                  />
                  <label>Route Name</label>
                  <span className="text-danger">{error?.route_name ?? ''}</span>

                </div>
                <div className="mb-3 form-floating form-floating-outline">
                  <input
                    type="number"
                    className="form-control"
                    name="route_fee"
                    required
                    placeholder="Route Fee"
                  />
                  <label>Route Fee</label>
                  <span className="text-danger">{error?.route_fee ?? ''}</span>

                </div>
                <div className="mb-3 form-floating form-floating-outline">
                  <select className="form-select" name="duration" required>
                    <option value="" selected disabled>
                      Select
                    </option>
                    <option value='1'>1 Month</option>
                    <option value='3'>3 Month</option>
                    <option value='6'>6 Month</option>
                    <option value='12'>12 Month</option>





                  </select>
                  <label>-- Select Month --</label>
                  <span className="text-danger">{error?.duration ?? ''}</span>

                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
               <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}  // Disable the button while loading
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    'Submit'
                  )}
                  {loading ? ' Submitting...' : ''}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="UpdateBus"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">

            <form onSubmit={updateBus}>

              <div className="modal-header bg-label-primary p-4">
                <h1 className="modal-title fs-5 " id="exampleModalLabel">
                  Update Bus Route
                </h1>
                <button
                  type="button"
                  className="btn-close "
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <input
                  type="hidden"
                  className="form-control"
                  placeholder="Enter bus number RJ01XX1234"
                  required
                  name="id"
                  value={modalData?.id}
                />
                <div className="mb-3 form-floating form-floating-outline">
                  <select className="form-select" name="bus_id" required>
                    <option value="" selected disabled>
                      Select Bus
                    </option>
                    {buses.map((bus) => (
                      <option key={bus.id} value={bus.id} selected={bus.id == modalData?.bus_id}>
                        {bus.bus_number}
                      </option>
                    ))}
                  </select>
                  <label>-- Select Bus --</label>
                  <span className="text-danger">{error?.bus_id ?? ''}</span>
                </div>
                <div className="mb-3 form-floating form-floating-outline">
                  <input
                    type="text"
                    className="form-control input-uppercase"
                    name="route_name"
                    required
                    placeholder="Route Name"
                    defaultValue={modalData?.route_name}
                  />
                  <label>Route Name</label>
                  <span className="text-danger">{error?.route_name ?? ''}</span>

                </div>
                <div className="mb-3 form-floating form-floating-outline">
                  <input
                    type="number"
                    className="form-control"
                    name="route_fee"
                    required
                    placeholder="Route Fee"
                    defaultValue={modalData?.route_fee}
                  />
                  <label>Route Fee</label>
                  <span className="text-danger">{error?.route_fee ?? ''}</span>

                </div>

                <div className="mb-3 form-floating form-floating-outline">
                  <select className="form-select" name="duration" required>
                    <option value="" selected disabled>
                      Select
                    </option>
                    <option>1 Month</option>
                    <option>6 Month</option>
                    <option>12 Month</option>
                  </select>
                  <label>-- Select Month --</label>
                  <span className="text-danger">{error?.duration ?? ''}</span>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                 <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}  // Disable the button while loading
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    'Submit'
                  )}
                  {loading ? ' Submitting...' : ''}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
